<template>
  <Layout>
    <div class="section content has-text-white">
      <h1 class="is-size-5 has-text-primary">{{ $t('Imprint') }}</h1>
      <span class="is-size-7">
        <p>
          Име на фирмата: 778mobile GmbH<br>
          Адрес на компанията: Am Wehrhahn 50, DE-40211 Düsseldorf, Germany<br>
          Електронна поща: <a class="has-text-primary" href="mailto:gamegame.bg@silverlines.info">gamegame.bg@silverlines.info</a><br>
          Линия за помощ: <a class="has-text-primary" href="tel:024928370">024928370</a> / <a class="has-text-primary" href="tel:024487202">024487202</a>
        </p>
      </span>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/GG'

export default {
  name: 'Imprint',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangGG/BG/Imprint.vue